import { render, staticRenderFns } from "./ComissoesColaboradores.vue?vue&type=template&id=fa8930e2&scoped=true"
import script from "./ComissoesColaboradores.vue?vue&type=script&lang=js"
export * from "./ComissoesColaboradores.vue?vue&type=script&lang=js"
import style0 from "./ComissoesColaboradores.vue?vue&type=style&index=0&id=fa8930e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8930e2",
  null
  
)

export default component.exports